import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const ChiSiamo: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Chi Siamo";
  }, []);

  return (
    <div className="bg-white">
      <PageHeader title="Chi Siamo" breadcrumb="Chi Siamo" />
      <div className="container px-4 py-12 mx-auto">
        <div className="grid gap-12 md:grid-cols-3">
          <div className="md:col-span-2">
            <section className="mb-12">
              <h2 className="mb-4 text-3xl font-bold text-gray-900">
                Qualità e Innovazione dal 1978
              </h2>
              <p className="mb-6 text-lg text-gray-700">
                Nata nel 1978, <strong>CO.ME.ST.</strong>, è oggi sinonimo di qualità al servizio dell'industria automobilistica.
              </p>
              <p className="mb-6 text-lg text-gray-700">
                In quasi 50 anni, l'originaria attività di fabbricazione e commercializzazione di accessori per auto si è profondamente evoluta, giungendo alla produzione di particolari destinati al primo impianto, forniti in tutto il mondo.
              </p>
              <p className="text-lg text-gray-700">
                <strong>CO.ME.ST.</strong> è presente nel mercato della produzione stampi, stampaggio lamiera a freddo e assemblaggio per il settore automotive e non solo.
              </p>
            </section>

            <section className="mb-12">
              <h3 className="mb-4 text-2xl font-semibold text-gray-800">
                Due Siti Produttivi, Una Sola Missione
              </h3>
              <p className="text-lg text-gray-700">
                Due siti produttivi in Italia, situati a Robassomero, la "<strong>Elpa Solutions</strong>" per la costruzione attrezzature, la gestione della pre-serie e piccole produzioni e la <strong>CO.ME.ST.</strong> per la produzione di serie, garantiscono una risposta rapida e completa alle esigenze del cliente.
              </p>
            </section>

            <section className="mb-12">
              <h3 className="mb-4 text-2xl font-semibold text-gray-800">
                Il Nostro Core Business
              </h3>
              <p className="mb-6 text-lg text-gray-700">
                Il core business aziendale è rappresentato dalla produzione e vendita di elementi di stampaggio e lastratura in acciaio e alluminio. L'innovazione delle idee unita all'impegno degli uomini conducono ad una continua crescita del know-how aziendale.
              </p>
              <p className="text-lg text-gray-700">
                L'Ufficio tecnico è in grado di utilizzare i più diffusi formati di progettazione 3D con l'ausilio dei più recenti sistemi CAD.
              </p>
            </section>

            <section>
              <h3 className="mb-4 text-2xl font-semibold text-gray-800">
                Impegno per la Qualità e la Sostenibilità
              </h3>
              <p className="mb-6 text-lg text-gray-700">
                La Qualità è impegnata a garantire la massima efficienza
                attraverso un sistema collaudato e suffragato delle
                certificazioni:
              </p>
              <ul className="mb-6 space-y-2 list-disc list-inside">
                <li>ISO 9001:2015</li>
                <li>IATF 16949:2016</li>
              </ul>
              <p className="mb-6 text-lg text-gray-700">
                <strong>CO.ME.ST.</strong> è fortemente impegnata su temi
                ambientali, sociali e di governance (ESG). Le strategie
                aziendali integrano:
              </p>
              <ul className="mb-6 space-y-2 list-disc list-inside">
                <li>Riduzione dell'impatto ambientale nei processi produttivi</li>
                <li>Promozione della sicurezza, formazione e benessere dei lavoratori</li>
                <li>Governance trasparente e responsabile</li>
              </ul>
              <p className="mb-6 text-lg text-gray-700">
                La sostenibilità non è solo un obiettivo, ma parte integrante della nostra crescita futura.
              </p>
              <p className="mb-6 text-lg text-gray-700">
                L'azienda ha adottato il <strong>Modello Organizzativo 231</strong>, in conformità al D.Lgs. 231/2001, per prevenire il rischio di reati nell'attività aziendale. A vigilare sul corretto funzionamento e aggiornamento del modello è stato istituito un <strong>Organismo di Vigilanza (OdV)</strong> autonomo e indipendente, che agisce secondo un preciso regolamento interno.
              </p>
              <p className="mb-6 text-lg text-gray-700">
                Forte di tutto ciò, <strong>CO.ME.ST.</strong> punta con convinzione alla soddisfazione della clientela in termini di competitività, professionalità servizio e qualità; tratti distintivi della mission aziendale!
              </p>
            </section>
          </div>

          <aside className="md:col-span-1">
            <div className="sticky top-24 text-center">
              <img
                src="/images/fondatore.jpg"
                alt="CO.ME.ST. S.r.l."
                className="w-full h-auto rounded-lg shadow-lg"
              />
              <div className="mt-4">
                <p className="text-gray-600">
                  Giordano Ghini, Fondatore della CO.ME.ST Srl
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default ChiSiamo; 